import 'can/model/';


const Skus = can.Model.extend({
    findAll: function() {
        "use strict";

        return can.ajax({
            url: "/api/v2/skus",
            type: "GET",
            dataType: "json"
        });
    }
}, {});

export default Skus;
